import { render, staticRenderFns } from "./BidForm.vue?vue&type=template&id=0bad0d3e&scoped=true&"
import script from "./BidForm.vue?vue&type=script&lang=js&"
export * from "./BidForm.vue?vue&type=script&lang=js&"
import style0 from "./BidForm.vue?vue&type=style&index=0&id=0bad0d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad0d3e",
  null
  
)

export default component.exports